import { neighborhoodCardGrid as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  header: 'Neighborhood header',
  neighborhoods: [
    {
      metadata: {
        tags: [
          {
            sys: {
              type: 'Link',
              linkType: 'Tag',
              id: 'freelancers',
            },
          },
          {
            sys: {
              type: 'Link',
              linkType: 'Tag',
              id: 'shopTester',
            },
          },
        ],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '3g4b24b0tvoz',
          },
        },
        id: '2oeerhHJsVfBe0q7pGZppH',
        type: 'Entry',
        createdAt: '2023-05-10T01:15:49.025Z',
        updatedAt: '2023-07-14T14:37:11.592Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        revision: 14,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'neighborhoodSingle',
          },
        },
        locale: 'en-US',
      },
      fields: {
        name: 'Missoula Valley Test',
        slug: 'missoula-valley-test',
        id: 'g30_c2qftskd',
        country: 'United States',
        featuredImg: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '1nS64kN5G00cOHrQadKF3a',
            type: 'Entry',
            createdAt: '2023-05-10T01:15:13.195Z',
            updatedAt: '2023-07-10T19:43:26.483Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 9,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'imageWithFocalPoint',
              },
            },
            locale: 'en-US',
          },
          fields: {
            title: 'Missoula Valley Image',
            image: {
              metadata: {
                tags: [],
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: '3g4b24b0tvoz',
                  },
                },
                id: '5vdGZZ814di2sGKFo9TDs9',
                type: 'Asset',
                createdAt: '2023-05-29T10:27:50.791Z',
                updatedAt: '2023-07-10T19:43:26.397Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment',
                  },
                },
                revision: 2,
                locale: 'en-US',
              },
              fields: {
                title: 'placeholder_16x9.3ed4dbb7.jpg',
                file: {
                  url: '/assets/textimageplaceholder.png',
                  details: {
                    size: 340075,
                    image: {
                      width: 1440,
                      height: 428,
                    },
                  },
                  fileName: 'placeholder_16x9.3ed4dbb7.jpg',
                  contentType: 'image/jpeg',
                },
              },
            },
            focalPoint: {
              focalPoint: {
                x: 230,
                y: 315,
              },
            },
          },
        },
        latlng: {
          lon: -113.994,
          lat: 46.87212,
        },
      },
    },
    {
      metadata: {
        tags: [
          {
            sys: {
              type: 'Link',
              linkType: 'Tag',
              id: 'shopTester',
            },
          },
        ],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '3g4b24b0tvoz',
          },
        },
        id: '48bA4XNI0OjwN1dLDfxTgn',
        type: 'Entry',
        createdAt: '2023-05-10T01:13:46.720Z',
        updatedAt: '2023-07-06T05:04:09.081Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        revision: 6,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'neighborhoodSingle',
          },
        },
        locale: 'en-US',
      },
      fields: {
        name: 'Flathead Valley Test',
        slug: 'flathead-valley-test',
        featuredImg: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '6xthAb1r30MC49hw74i2e',
            type: 'Entry',
            createdAt: '2023-05-10T01:12:11.007Z',
            updatedAt: '2023-05-16T19:23:54.344Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 4,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'imageWithFocalPoint',
              },
            },
            locale: 'en-US',
          },
          fields: {
            title: 'Flathead Valley ',
            image: {
              metadata: {
                tags: [],
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: '3g4b24b0tvoz',
                  },
                },
                id: 's82fetNRnmsj14W9s6lRk',
                type: 'Asset',
                createdAt: '2023-04-25T01:04:44.827Z',
                updatedAt: '2023-05-16T19:23:53.923Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment',
                  },
                },
                revision: 9,
                locale: 'en-US',
              },
              fields: {
                title: 'Neighborhood Card Desktop',
                description: '',
                file: {
                  url: '/assets/textimageplaceholder.png',
                  details: {
                    size: 711682,
                    image: {
                      width: 1272,
                      height: 408,
                    },
                  },
                  fileName: 'Neighborhood_Card_Desktop.png',
                  contentType: 'image/png',
                },
              },
            },
            focalPoint: {
              focalPoint: {
                x: 171,
                y: 153,
              },
            },
          },
        },
        latlng: {
          lon: -114.153,
          lat: 48.42415,
        },
      },
    },
    {
      metadata: {
        tags: [
          {
            sys: {
              type: 'Link',
              linkType: 'Tag',
              id: 'shopTester',
            },
          },
        ],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '3g4b24b0tvoz',
          },
        },
        id: '4azWgbbCW8Umh3KfsGb2cA',
        type: 'Entry',
        createdAt: '2023-05-10T01:18:21.875Z',
        updatedAt: '2023-05-16T19:23:54.260Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'neighborhoodSingle',
          },
        },
        locale: 'en-US',
      },
      fields: {
        name: 'Capital Hill Test',
        slug: 'capital-hill-test',
        featuredImg: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '29hKWb0bPjcIFu48MmIfqi',
            type: 'Entry',
            createdAt: '2023-05-10T01:18:16.412Z',
            updatedAt: '2023-05-22T10:40:44.814Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 14,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'imageWithFocalPoint',
              },
            },
            locale: 'en-US',
          },
          fields: {
            title: 'Capital Hill',
            image: {
              metadata: {
                tags: [],
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: '3g4b24b0tvoz',
                  },
                },
                id: '2TyXPUlncgBEngOTp3h1Y8',
                type: 'Asset',
                createdAt: '2023-04-06T19:33:13.509Z',
                updatedAt: '2023-05-22T10:40:43.977Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment',
                  },
                },
                revision: 14,
                locale: 'en-US',
              },
              fields: {
                title: 'Highland, Denver, CO',
                description: '',
                file: {
                  url: '/assets/textimageplaceholder.png',
                  details: {
                    size: 1888755,
                    image: {
                      width: 1272,
                      height: 590,
                    },
                  },
                  fileName: 'highland_hero.png',
                  contentType: 'image/png',
                },
              },
            },
            focalPoint: {
              focalPoint: {
                x: 949,
                y: 339,
              },
            },
          },
        },
        latlng: {
          lat: 38.88604,
          lon: -76.9995,
        },
      },
    },
    {
      metadata: {
        tags: [
          {
            sys: {
              type: 'Link',
              linkType: 'Tag',
              id: 'shopTester',
            },
          },
        ],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '3g4b24b0tvoz',
          },
        },
        id: '4azWgbbCW8Umh3KfsGb2cA',
        type: 'Entry',
        createdAt: '2023-05-10T01:18:21.875Z',
        updatedAt: '2023-05-16T19:23:54.260Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'neighborhoodSingle',
          },
        },
        locale: 'en-US',
      },
      fields: {
        name: 'Capital Hill Test',
        slug: 'capital-hill-test',
        featuredImg: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '29hKWb0bPjcIFu48MmIfqi',
            type: 'Entry',
            createdAt: '2023-05-10T01:18:16.412Z',
            updatedAt: '2023-05-22T10:40:44.814Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 14,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'imageWithFocalPoint',
              },
            },
            locale: 'en-US',
          },
          fields: {
            title: 'Capital Hill',
            image: {
              metadata: {
                tags: [],
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: '3g4b24b0tvoz',
                  },
                },
                id: '2TyXPUlncgBEngOTp3h1Y8',
                type: 'Asset',
                createdAt: '2023-04-06T19:33:13.509Z',
                updatedAt: '2023-05-22T10:40:43.977Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment',
                  },
                },
                revision: 14,
                locale: 'en-US',
              },
              fields: {
                title: 'Highland, Denver, CO',
                description: '',
                file: {
                  url: '/assets/textimageplaceholder.png',
                  details: {
                    size: 1888755,
                    image: {
                      width: 1272,
                      height: 590,
                    },
                  },
                  fileName: 'highland_hero.png',
                  contentType: 'image/png',
                },
              },
            },
            focalPoint: {
              focalPoint: {
                x: 949,
                y: 339,
              },
            },
          },
        },
        latlng: {
          lat: 38.88604,
          lon: -76.9995,
        },
      },
    },
    {
      metadata: {
        tags: [
          {
            sys: {
              type: 'Link',
              linkType: 'Tag',
              id: 'shopTester',
            },
          },
        ],
      },
      sys: {
        space: {
          sys: {
            type: 'Link',
            linkType: 'Space',
            id: '3g4b24b0tvoz',
          },
        },
        id: '4azWgbbCW8Umh3KfsGb2cA',
        type: 'Entry',
        createdAt: '2023-05-10T01:18:21.875Z',
        updatedAt: '2023-05-16T19:23:54.260Z',
        environment: {
          sys: {
            id: 'master',
            type: 'Link',
            linkType: 'Environment',
          },
        },
        revision: 5,
        contentType: {
          sys: {
            type: 'Link',
            linkType: 'ContentType',
            id: 'neighborhoodSingle',
          },
        },
        locale: 'en-US',
      },
      fields: {
        name: 'Capital Hill Test',
        slug: 'capital-hill-test',
        featuredImg: {
          metadata: {
            tags: [],
          },
          sys: {
            space: {
              sys: {
                type: 'Link',
                linkType: 'Space',
                id: '3g4b24b0tvoz',
              },
            },
            id: '29hKWb0bPjcIFu48MmIfqi',
            type: 'Entry',
            createdAt: '2023-05-10T01:18:16.412Z',
            updatedAt: '2023-05-22T10:40:44.814Z',
            environment: {
              sys: {
                id: 'master',
                type: 'Link',
                linkType: 'Environment',
              },
            },
            revision: 14,
            contentType: {
              sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'imageWithFocalPoint',
              },
            },
            locale: 'en-US',
          },
          fields: {
            title: 'Capital Hill',
            image: {
              metadata: {
                tags: [],
              },
              sys: {
                space: {
                  sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: '3g4b24b0tvoz',
                  },
                },
                id: '2TyXPUlncgBEngOTp3h1Y8',
                type: 'Asset',
                createdAt: '2023-04-06T19:33:13.509Z',
                updatedAt: '2023-05-22T10:40:43.977Z',
                environment: {
                  sys: {
                    id: 'master',
                    type: 'Link',
                    linkType: 'Environment',
                  },
                },
                revision: 14,
                locale: 'en-US',
              },
              fields: {
                title: 'Highland, Denver, CO',
                description: '',
                file: {
                  url: '/assets/textimageplaceholder.png',
                  details: {
                    size: 1888755,
                    image: {
                      width: 1272,
                      height: 590,
                    },
                  },
                  fileName: 'highland_hero.png',
                  contentType: 'image/png',
                },
              },
            },
            focalPoint: {
              focalPoint: {
                x: 949,
                y: 339,
              },
            },
          },
        },
        latlng: {
          lat: 38.88604,
          lon: -76.9995,
        },
      },
    },
  ],
  ctaUrl: '/neighborhoods',
};

export default fakeProps(schema, TestData);
